import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  headers: { "Content-Type": "application/json" },
});

// Attach admin token if present
api.interceptors.request.use((config) => {
  const t = localStorage.getItem("asahni_admin_token");
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export const SITE = {
  name: "Ajay Sahni",
  initials: "AS",
  domain: "aksahni.com",
  tagline: "Microsoft / Cybersecurity Strategist • AI Security Mentor",
  email: "connect@aksahni.com",
  whatsapp: "+91-8073670944",
  whatsappLink: "https://wa.me/918073670944",
  linkedin: "https://www.linkedin.com/in/ajay-kumar-15391a11/",
  portrait:
    "https://customer-assets.emergentagent.com/job_cloud-architect-pro-5/artifacts/rr0202m6_Business-Selfi.png",
};
